var map = {
	"./JuniorSantos.jpg": 2286,
	"./Moreira.jpeg": 2287,
	"./Mota.png": 2288,
	"./Peixoto.jpg": 2289,
	"./PinheiroCampos.jpg": 2290,
	"./Redighieri.jpg": 2291,
	"./Spezia.jpg": 2292,
	"./Teixeira.jpg": 2293,
	"./Tozzini.jpg": 2294,
	"./author.png": 650
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2285;